import { Box, Button, Card, Chip, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputBase, InputLabel, MenuItem, Paper, Popover, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import PaginationComponent from 'src/components/pagination';
import { deleteData, getData, postData } from 'src/webService/webService';


function UserPage() {

    const [formOpen, setFormOpen] = useState(false);
    const [open, setOpen] = useState(null);
    const [name, setName] = useState("");
    const [contact, setContact] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [users, setUsers] = useState([]);
    const [teamType, setTeamType] = useState('');
    const [specificRole, setSpecificRole] = useState('');
    const [selectedUserId, setSelectedUserId] = useState();

    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const handleOpen = () => setFormOpen(true);
    const handleClose = () => setFormOpen(false);

    const handleOpenMenu = (event, userId) => {
        setOpen(event.currentTarget);
        setSelectedUserId(userId);
    };

    const handleCloseMenu = () => {
        setOpen(null);
        setSelectedUserId(null);
    };

    const sessionToken = sessionStorage.getItem("Token");

    const getAllUsers = async (page, limit, search) => {
        const params = {
            page: page,
            limit: limit,
            search: search ? search : ""
        };
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData("users/users", params, sessionToken);
            console.log("Response:", response)

            const responseData = response.data.results;
            const totalRecords = response.data.totalItems;

            setTotalPages(response.data.totalPages);
            setUsers(responseData);
            setTotalCount(totalRecords);

        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    useEffect(() => {
        getAllUsers(currentPage, limit);
    }, [currentPage, limit])


    const generateRandomPassword = (length = 12) => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger;

        const generatedPassword = generateRandomPassword();

        const newUser = {
            name: name,
            phoneNumber: contact,
            email: email,
            password: generatedPassword,
            role: role,
            ...(role !== "Admin" && { roleType: specificRole }),
            ...(role === "Service" && { serviceTeamType: teamType }),
        };


        try {
            const response = await postData("users/signup", newUser, sessionToken);
            console.log("Response:", response);

            if (response.status === 200) {
                setUsers([...users, response.data]);
                setName("");
                setContact("");
                setEmail("");
                setRole("");
                setTeamType("");
                setSpecificRole("");
                handleClose();
                toast.success("User Added Successfully!")
            } else {
                toast.error(response?.message)
                throw new Error(response.message || "Failed to add user");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(`Something went wrong. Please try again! ${error ? error : ''}`);
        }
        getAllUsers();
    };

    const inputStyle = {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '12px',
        marginBottom: '16px'
    };

    const handleDelete = async (id) => {
        if (!id) {
            console.error("User ID is undefined.");
            return;
        }
        try {
            const response = await deleteData(`users/user/${id}`, sessionToken);
            console.log(response.message);
            toast.success("User deleted successfully!");
            setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error(`${error ? error : ''}`);
        }
        getAllUsers();
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllUsers(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllUsers(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllUsers(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    // Searchlogic
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000);

        return () => {
            clearTimeout(handler);
        };
    }, [query]);

    const handleChange = (event) => {
        setQuery(event.target.value);
        setCurrentPage(1);
        setLimit(5);
    };

    // Use debouncedQuery for API calls or filtering  
    useEffect(() => {
        if (debouncedQuery) {
            getAllUsers(currentPage, limit, debouncedQuery)
        }
    }, [currentPage, limit, debouncedQuery]);

    const handleClear = () => {
        setQuery('');
        setDebouncedQuery('');
        setCurrentPage(1);
        setLimit(5);
        getAllUsers(1, 5, "");
    };

    return (
        <>
            <Helmet>
                <title>Users Page</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Users
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <form className="d-flex" style={{ marginRight: '10px' }}>
                            <TextField
                                size="small"
                                variant="outlined"
                                placeholder="Search"
                                value={query}
                                onChange={handleChange}
                            />
                            {
                                query &&
                                <IconButton onClick={handleClear} size="small">
                                    <Iconify icon="carbon:close-filled" style={{ color: "red" }} />
                                </IconButton>
                            }
                        </form>
                        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpen}>
                            Add User
                        </Button>
                    </Box>
                </Stack>
                <Card sx={{ padding: 1, boxShadow: 3, backgroundColor: "#fff" }}>
                    {/* Projects Table */}
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    {/* <TableCell>Contact</TableCell> */}
                                    <TableCell>Role</TableCell>
                                    <TableCell>Role Type</TableCell>
                                    <TableCell>Service Team</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    totalCount === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        users.map((user, id) => (
                                            <TableRow key={user.id}>
                                                <TableCell>{calculateIndex(id)}</TableCell>
                                                <TableCell>{user.name}</TableCell>
                                                <TableCell>{user.email}</TableCell>
                                                {/* <TableCell>{user.phoneNumber}</TableCell> */}
                                                <TableCell>{user.role}</TableCell>
                                                <TableCell>{user.roleType}</TableCell>
                                                <TableCell>{user?.serviceTeamType ? user?.serviceTeamType : "-"}</TableCell>
                                                <TableCell>
                                                    <Iconify icon="mdi:dots-vertical"
                                                        sx={{ cursor: 'pointer' }}
                                                        onClick={(event) => handleOpenMenu(event, user._id)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <PaginationComponent
                        name={"Users"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />

                </Card>

                <Dialog open={formOpen} onClose={handleClose}>
                    <DialogTitle>Add User</DialogTitle>
                    <DialogContent>
                        <TextField label="Name" fullWidth value={name} onChange={(e) => setName(e.target.value)} sx={inputStyle} />
                        <TextField label="Email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} sx={inputStyle} />
                        <TextField label="Contact" fullWidth value={contact} onChange={(e) => setContact(e.target.value)} sx={inputStyle} />

                        <FormControl sx={inputStyle}>
                            <InputLabel>Role</InputLabel>
                            <Select value={role} onChange={(e) => setRole(e.target.value)}>
                                <MenuItem value="Admin">Admin</MenuItem>
                                <MenuItem value="Sales">Sales</MenuItem>
                                <MenuItem value="Service">Service</MenuItem>
                            </Select>
                        </FormControl>

                        {role === 'Sales' && (
                            <FormControl sx={inputStyle}>
                                <InputLabel>Select SubRole</InputLabel>
                                <Select value={specificRole} onChange={(e) => setSpecificRole(e.target.value)}>
                                    <MenuItem value="Team Leader">Team Leader</MenuItem>
                                    <MenuItem value="Employee">Employee</MenuItem>
                                </Select>
                            </FormControl>
                        )}

                        {role === 'Service' && (
                            <>
                                <FormControl sx={inputStyle}>
                                    <InputLabel>Select Service Type</InputLabel>
                                    <Select value={teamType} onChange={(e) => setTeamType(e.target.value)}>
                                        {/* <MenuItem value="Google SEO">Google SEO</MenuItem> */}
                                        <MenuItem value="SEO">SEO</MenuItem>
                                        <MenuItem value="WebSite Designing">WebSite Designing</MenuItem>
                                        <MenuItem value="Content Creation">Content Creation</MenuItem>
                                        <MenuItem value="Camera Man">Camera Man</MenuItem>
                                        <MenuItem value="Video Editing">Video Editing</MenuItem>
                                        <MenuItem value="Graphic Designing">Graphic Designing</MenuItem>
                                        <MenuItem value="Social Media">Social Media</MenuItem>
                                    </Select>
                                </FormControl>
                                {teamType && (
                                    <FormControl sx={inputStyle}>
                                        <InputLabel>Select SubRole</InputLabel>
                                        <Select value={specificRole} onChange={(e) => setSpecificRole(e.target.value)}>
                                            <MenuItem value="Team Leader">Team Leader</MenuItem>
                                            <MenuItem value="Employee">Employee</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary">Cancel</Button>
                        <Button onClick={handleSubmit} color="primary">Add</Button>
                    </DialogActions>
                </Dialog>

                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {/* <MenuItem>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                        Edit
                    </MenuItem> */}
                    <MenuItem
                        sx={{ color: 'error.main' }}
                        onClick={() => {
                            if (!selectedUserId) {
                                toast.error('No user selected. Please try again.');
                                return;
                            }
                            const confirmDelete = window.confirm('Are you sure you want to delete this user?');
                            if (confirmDelete) {
                                handleDelete(selectedUserId);
                                handleCloseMenu();
                            }
                        }}
                    >
                        <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                        Delete
                    </MenuItem>
                </Popover>
            </Container>
        </>
    )
}

export default UserPage
